module.exports = __webpack_public_path__ + "static/media/arrowleftbox.efc014ad.svg";